
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Ang AlertProvider ay nasa App.js na -- huwag nang ulitin dito.
// Dati may dalawa (isa dito, isa sa App.js). Ang nasa loob ang laging
// nananalo, kaya walang epekto ang settings na nakasulat sa file na ito.

const root = createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Naka-off ang service worker (default ito ng Create React App).
// Kung gusto ninyong gumana offline, palitan ng serviceWorker.register()
// -- pero mag-iingat: puwedeng mag-cache ng lumang build.
serviceWorker.unregister();

